import React from 'react';

const PrivacyPolicy = () => {
    return (
        <div className="max-w-2xl mx-auto p-4">
            <h1 className="text-2xl font-bold mb-4">นโยบายความเป็นส่วนตัว</h1>
            <p className="mb-4">
                ความเป็นส่วนตัวของคุณมีความสำคัญต่อเรา นโยบายความเป็นส่วนตัวนี้อธิบายว่าเรารวบรวม ใช้ และปกป้องข้อมูลของคุณอย่างไร
            </p>
            <h2 className="text-xl font-semibold mb-2">การเก็บรวบรวมข้อมูล</h2>
            <p className="mb-4">
                เราอาจเก็บรวบรวมข้อมูลส่วนบุคคลจากคุณเมื่อคุณใช้แอปของเรา รวมถึงแต่ไม่จำกัดเพียงชื่อ ที่อยู่อีเมล และข้อมูลการใช้งาน
            </p>
            <h2 className="text-xl font-semibold mb-2">การใช้ข้อมูล</h2>
            <p className="mb-4">
                เราใช้ข้อมูลที่เรารวบรวมเพื่อให้บริการและปรับปรุงบริการของเรา สื่อสารกับคุณ และปฏิบัติตามข้อกำหนดทางกฎหมาย
            </p>
            <h2 className="text-xl font-semibold mb-2">การปกป้องข้อมูล</h2>
            <p className="mb-4">
                เราใช้มาตรการรักษาความปลอดภัยที่เหมาะสมเพื่อปกป้องข้อมูลส่วนบุคคลของคุณจากการเข้าถึง การเปลี่ยนแปลง การเปิดเผย หรือการทำลายที่ไม่ได้รับอนุญาต
            </p>
            <h2 className="text-xl font-semibold mb-2">การเปลี่ยนแปลงนโยบายนี้</h2>
            <p className="mb-4">
                เราอาจปรับปรุงนโยบายความเป็นส่วนตัวนี้เป็นครั้งคราว เราจะแจ้งให้คุณทราบเกี่ยวกับการเปลี่ยนแปลงใด ๆ โดยการโพสต์นโยบายใหม่ในหน้านี้
            </p>
            <h2 className="text-xl font-semibold mb-2">ติดต่อเรา</h2>
            <p>
                หากคุณมีคำถามเกี่ยวกับนโยบายความเป็นส่วนตัวนี้ โปรดติดต่อเราที่ hi@kamnuannom.com
            </p>
        </div>
    );
};

export default PrivacyPolicy;
